export type PatientDetailsType = {
  // id: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  appointmentType?: string;
  appointmentStatus?: string;
  consultingSlot: string;
  appointmentTimes: string;
};

export type PatientInputDetailsType = {
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  email?: string;
  refferedby?: string;
};

export type ConsultingSlotsType = {
  start: string;
  end: string;
};

export enum ConsultingSlot {
  DAY,
  EVENING,
}
